import React from "react";

/**
 * Configuration du tier (chaud / tiède / froid) pour l'évaluation IA.
 * Couleurs cohérentes avec la palette Blitzz, supporte mode sombre via /20 opacité.
 */
const TIER_CONFIG = {
  hot: {
    label: "CHAUD",
    bg: "bg-rose-500/15",
    text: "text-rose-400",
    border: "border-rose-500/40",
    ring: "ring-rose-500/30",
    icon: "🔥",
    gradient: "from-rose-500 to-orange-500",
  },
  warm: {
    label: "TIÈDE",
    bg: "bg-amber-500/15",
    text: "text-amber-400",
    border: "border-amber-500/40",
    ring: "ring-amber-500/30",
    icon: "🌤️",
    gradient: "from-amber-500 to-yellow-500",
  },
  cold: {
    label: "FROID",
    bg: "bg-sky-500/15",
    text: "text-sky-400",
    border: "border-sky-500/40",
    ring: "ring-sky-500/30",
    icon: "❄️",
    gradient: "from-sky-500 to-cyan-500",
  },
};

export const tierConfig = (tier) => TIER_CONFIG[tier] || TIER_CONFIG.cold;

/**
 * Petit badge compact affichant le score IA et le tier.
 * Utilisé dans la liste, le hero, le Dialog compact.
 */
export const AIScoreBadge = ({ tier, score, size = "md", testId = "ai-score-badge" }) => {
  const cfg = tierConfig(tier);
  if (typeof score !== "number") return null;
  const sizes = {
    sm: "text-[10px] px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold ${cfg.bg} ${cfg.text} border ${cfg.border} ${sizes[size]}`}
      data-testid={testId}
    >
      <span className="text-[1.1em] leading-none">{cfg.icon}</span>
      <span>
        {cfg.label} · {score}/100
      </span>
    </span>
  );
};

export default AIScoreBadge;
